import React, { useContext } from 'react'

export const TasksContext = React.createContext({
  tasks: {},
  // setTasks: () => {},
})

export const useTasks = () => useContext(TasksContext)
